import React from "react";
import Auth from "../../services/Auth/Auth";
import ROLES from "../../utils/constants/roles.constants";
import ManajerHome from "./ManajerHome";
import AnonHome from "./AnonHome";
import DosenHome from "./DosenHome";
import MahasiswaHome from "./MahasiswaHome";

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentUser: Auth.getCurrentUser(),
    };
  }
  render() {
    const { currentUser } = this.state;
    return (
      <div>
        {!currentUser && <AnonHome />}
        {currentUser &&
          (currentUser.role === ROLES.ADMIN ||
            currentUser.role === ROLES.MANAJER) && <ManajerHome />}
        {currentUser && currentUser.role === ROLES.DOSEN && <DosenHome />}
        {currentUser && currentUser.role === ROLES.MAHASISWA && (
          <MahasiswaHome />
        )}
      </div>
    );
  }
}
